module.exports = __webpack_public_path__ + "media/images/gcash-logo-399fdc81fcb3bf74e7f5a79207a8f33e.png";